// extracted by mini-css-extract-plugin
module.exports = {"title":"card_title__sSdcu"};